exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".curriculumLDocumentComponent---1I_vX{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;font-family:Poppins,sans-serif;background-color:#cfd2d4;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.curriculumLDocumentComponent---1I_vX .curriculumFilterComponent---2oGK6{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;padding:0 25px;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;min-height:80px}.curriculumLDocumentComponent---1I_vX .curriculumFilterComponent---2oGK6 .uploadButton---2ZI7B{height:40px;margin-left:16px;margin-left:1rem}", ""]);

// exports
exports.locals = {
	"curriculumLDocumentComponent": "curriculumLDocumentComponent---1I_vX",
	"curriculumFilterComponent": "curriculumFilterComponent---2oGK6",
	"uploadButton": "uploadButton---2ZI7B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/curriculum-documents/index.scss
// module id = 752
// module chunks = 3